import styled from "@emotion/styled";
export const StyledCreditsSpecialOffer = styled.div`
  color: #0F9B63;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
  line-height: 1.4;
  min-height: calc(2 * 1.4 * 0.875rem);
`;
